import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStepInProgress = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			transform: "translate(0.799805 0.000976562)",
			fill: "white",
			style: { mixBlendMode: "multiply" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.7998 15.501C4.65767 15.501 1.2998 12.1431 1.2998 8.00098C1.2998 3.85884 4.65767 0.500977 8.7998 0.500977V15.501Z",
			fill: "#001489"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.80022,
			cy: 8.00097,
			r: 6.96429,
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeDasharray: "1 3"
		})
	]
});
const ForwardRef = forwardRef(SvgStepInProgress);
export default ForwardRef;
